import { render, staticRenderFns } from "./yaerNewProductOverview.vue?vue&type=template&id=31165980&scoped=true&"
import script from "./yaerNewProductOverview.vue?vue&type=script&lang=js&"
export * from "./yaerNewProductOverview.vue?vue&type=script&lang=js&"
import style0 from "./yaerNewProductOverview.vue?vue&type=style&index=0&id=31165980&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31165980",
  null
  
)

export default component.exports